import React, { FormEvent, useEffect, useState } from "react"

import { useAuth } from "../../hooks/useAuth";

import axios from "axios";

import { FaSearch } from "react-icons/fa";

import {
    Container,
    Main,
    Table,
    TableBody,
    TableHeader,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableHeadRow,
    FilterButton,
    FilterContainer,
    FilterInput,
    FilterInputContainer,
    FormContainer,
    Loading
} from './styles';

interface IWorkLogProps {
    id: string;
    author: string;
    comment: string;
    started: string;
    timeSpent: string;
    timeSpentSeconds: number;
}

function parseData(data: any, timezone: string) {
    const date = new Date(String(data));
    const timeFormat: Intl.DateTimeFormatOptions = { month: '2-digit', day: '2-digit', year: '2-digit', timeZone: timezone, hour: '2-digit', minute: '2-digit' };
    let result: string = date.toLocaleString('pt-BR', timeFormat);
    return result;
}

const Follow: React.FC = () => {

    const { user } = useAuth();

    const [loading, setLoading] = useState(true);
    const [access, setAccess] = useState<boolean>(!user.clientJiraCodSup);

    const [worklogs, setWorklogs] = useState<IWorkLogProps[]>([]);
    const [showWorklogs, setShowdWorklogs] = useState<IWorkLogProps[]>([]);

    const [dataInicio, setDataInicio] = useState<number>(new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime());
    const [dataTermino, setDataTermino] = useState<number>(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getTime());

    const [searchText, setSearchText] = useState('');
    const [totalTime, setTotaltime] = useState('');

    const [periodOption, setPeriodOption] = useState('Mês atual');

    useEffect(() => {

        loadSupports();
        setLoading(false);

    }, [dataInicio]);

    useEffect(() => {

        calculateTotalTime();

    }, [showWorklogs]);

    function calculateTotalTime() {
        let totalSegundos = 0;
        showWorklogs.forEach((value: IWorkLogProps) => {
            totalSegundos += value.timeSpentSeconds;
        });
        if (totalSegundos > 0) {
            const totalMinutos = (totalSegundos / 60);
            const minMensagem = (totalMinutos % 60);
            
            const horasMensagem = Math.floor(totalMinutos / 60);
            
            const mensagem = `${horasMensagem}h ${minMensagem}min`
            setTotaltime(mensagem);
        }

    }

    function handleFilter(event: FormEvent) {
        event.preventDefault();

        if (searchText === '') {
            setShowdWorklogs(worklogs);
            return;
        }

        const newWorklogs = worklogs.filter(item => {
            if (item.comment.includes(searchText)) {
                return item;
            }
        })
        setShowdWorklogs(newWorklogs);
        calculateTotalTime();
    }

    function handlePeriodChange(event: React.ChangeEvent<HTMLInputElement>) {

        setPeriodOption(event.target.value);
        setSearchText('');

        const data = new Date();

        switch (event.target.value) {
            case 'Últimos 7 dias':
                setDataInicio(new Date().setDate(data.getDate() - 7));
                setDataTermino(data.getTime());
                break;

            case 'Mês atual':
                setDataInicio(new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime());
                setDataTermino(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getTime());
                break;

            case 'Mês anterior':
                setDataInicio(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).getTime());
                setDataTermino(new Date(new Date().getFullYear(), new Date().getMonth(), 0).getTime());
                break;

            case 'Últimos 45 dias':
                setDataInicio(new Date().setDate(data.getDate() - 45));
                setDataTermino(data.getTime());
                break;

            case 'Últimos 60 dias':
                setDataInicio(new Date().setDate(data.getDate() - 60));
                setDataTermino(data.getTime());
                break;

            default:
                break;
        }
    }

    async function loadSupports() {
        var auxDataInicioDate = new Date(dataInicio);
        var auxDataInicioNumber = auxDataInicioDate.setHours(0, 0, 0);

        var auxDataTerminoDate = new Date(dataTermino);
        var auxDataTerminoNumber = auxDataTerminoDate.setHours(23, 59, 59);
        

        await axios.get(`https://hook.us1.make.com/mgn3ypdyqciy2fng9ebx2r36hvpmrfm5`, {
            params: {
                operacao: 'suporte',
                issue: user.clientJiraCodSup,
                startedAfter: auxDataInicioNumber,
                startedBefore: auxDataTerminoNumber
            }
        }).then(response => {
            const r = response.data.map((item: any): IWorkLogProps => {
                return {
                    id: item.id,
                    author: item.author.displayName,
                    comment: item?.comment?.content[0]?.content[0]?.text,
                    started: item?.started,
                    timeSpent: item?.timeSpent,
                    timeSpentSeconds: item?.timeSpentSeconds
                }
            })
            setWorklogs(r);
            setShowdWorklogs(r);
            
        }).catch(error => {
            console.log(error)
        })

        await new Promise(f => setTimeout(f, 1000));

    }

    if (loading) {
        return (
            <Loading>
                <div></div>
            </Loading>
        )
    }

    if (access) {
        return (
            <div>
                <h3>Funcionalidade ainda em desenvolvimento, em breve você terá acesso a essa área.</h3>
            </div>
        )
    }


    return (
        <Container>
            <Main>
                <h1>Suportes</h1>

                <FilterContainer>
                    <FormContainer onSubmit={handleFilter}>
                        <FilterContainer>
                            <FilterInputContainer>
                                <FaSearch />
                                <FilterInput
                                    placeholder="Pesquise..."
                                    onChange={e => setSearchText(e.target.value)}
                                />
                            </FilterInputContainer>
                        </FilterContainer>
                        <FilterButton type="submit">
                            Buscar
                        </FilterButton>
                    </FormContainer>

                    <div>
                        <label>
                            <input
                                type="radio"
                                id="ultimos7Dias"
                                name="periodo"
                                value="Últimos 7 dias"
                                onChange={handlePeriodChange} />
                            Últimos 7 dias
                        </label><br />

                        <label>
                            <input
                                type="radio"
                                id="mesAtual"
                                name="periodo"
                                value="Mês atual"
                                onChange={handlePeriodChange}
                                defaultChecked={true} />
                            Mês atual
                        </label><br />

                        <label>
                            <input
                                type="radio"
                                id="mesAnterior"
                                name="periodo"
                                value="Mês anterior"
                                onChange={handlePeriodChange} />
                            Mês anterior
                        </label><br />

                        <label>
                            <input
                                type="radio"
                                id="ultimos45Dias"
                                name="periodo"
                                value="Últimos 45 dias"
                                onChange={handlePeriodChange} />
                            Últimos 45 dias
                        </label><br />

                        <label>
                            <input
                                type="radio"
                                id="ultimos60Dias"
                                name="periodo"
                                value="Últimos 60 dias"
                                onChange={handlePeriodChange} />
                            Últimos 60 dias
                        </label><br />
                    </div>
                </FilterContainer>
                <div>
                    Tempo total: {totalTime}
                </div>

                <TableContainer>
                    <Table>
                        <TableHeader>
                            <TableHeadRow>
                                {/* <TableHead></TableHead> */}
                                <TableHead>Desenvolvedor</TableHead>
                                <TableHead>Tempo</TableHead>
                                <TableHead>Comentário</TableHead>
                                <TableHead>Iniciado em</TableHead>
                            </TableHeadRow>
                        </TableHeader>

                        <TableBody>
                            {showWorklogs.map(item => {
                                var startedDate = parseData(item.started, 'America/Sao_Paulo');
                                return (
                                    <TableRow key={item?.id}>
                                        {/* <TableCell></TableCell> */}
                                        <TableCell>{item?.author}</TableCell>
                                        <TableCell>{item?.timeSpent}</TableCell>
                                        <TableCell>{item?.comment}</TableCell>
                                        <TableCell>{startedDate}</TableCell>
                                    </TableRow>

                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Main>

        </Container>
    )
}

export default Follow;
